import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "In 2012, according to International Air Transport Association (IATA), 26million luggages in worldwide airports were mishandled, costing airlines over $3billion. In US alone, over 400million luggage were handled in US airports, nearly 2million luggage were mishandled. eGeeTouch® luggage lock is optionally embedded with RFID microchips containing name, telephone number and email address that could be identified only by airport authorized personnel to prevent luggage from getting misplaced in the airport and facilitate for ease of claim in the event of lost belongings.",
    reply2:
      "eGeeTouch® smart padlock tracks WHO, WHEN & WHERE an access was made, providing an audit trail/log - a security-relevant chronological record, containing documentary evidence of the sequence of access history which is a highly useful feature unmatched by any conventional mechanical padlock.",
    back: "Back",
  },
  ja: {
    reply1:
      "国際航空運送協会（IATA）によると、2012年には世界中の空港で2,600万個の手荷物が誤って扱われ、航空会社に30億ドル以上の損害が発生した。米国だけでも、4億以上の手荷物が米国の空港で扱われ、200万近くの手荷物が誤って取り扱われました。 eGeeTouch® 荷物ロックには、空港内での荷物の置き忘れを防ぎ、持ち物を紛失した場合の受け取りを容易にするために、空港の認可を受けた職員のみが識別できる名前、電話番号、電子メール アドレスを含む RFID マイクロチップがオプションで埋め込まれています。",
    reply2:
      "eGeeTouch® スマート南京錠は、アクセスが誰、いつ、どこで行われたかを追跡し、監査証跡/ログを提供します。監査証跡/ログは、一連のアクセス履歴の文書証拠を含むセキュリティ関連の時系列記録であり、従来の機械式南京錠にはない非常に便利な機能です。",
    back: "戻る",
  },
  es: {
    reply1:
      "En 2012, según la Asociación de Transporte Aéreo Internacional (IATA), 26 millones de equipajes en los aeropuertos de todo el mundo fueron mal manejados, lo que costó a las aerolíneas más de 3 mil millones de dólares. Sólo en US, se manipularon más de 400 millones de equipaje en los aeropuertos estadounidenses y casi 2 millones de equipaje se manipularon incorrectamente. El candado para equipaje eGeeTouch® está integrado opcionalmente con microchips RFID que contienen nombre, número de teléfono y dirección de correo electrónico que solo pueden ser identificados por el personal autorizado del aeropuerto para evitar que el equipaje se extravíe en el aeropuerto y facilitar el reclamo en caso de pérdida de pertenencias.",
    reply2:
      "El candado inteligente eGeeTouch® rastrea QUIÉN, CUÁNDO Y DÓNDE se realizó un acceso, proporcionando un registro/pista de auditoría: un registro cronológico relevante para la seguridad, que contiene evidencia documental de la secuencia del historial de acceso, lo cual es una característica muy útil que no tiene comparación con ningún candado mecánico convencional.",
    back: "Atrás",
  },
});

class Q21_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q21_component;
